import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';
import { CreateRestaurantFormData } from '../../../app/data/models/restaurants/createRestaurantFormData';
import api from '../../../app/api/api';
import { fetchRestaurantListAsync } from './restaurantSlice';

interface UpdateRestaurantState {
  status: string;
}

const initialState: UpdateRestaurantState = {
  status: 'idle',
};

export const updateRestaurantAsync = createAsyncThunk<
  void,
  { id: string; data: CreateRestaurantFormData }
>('restaurants/update', async ({ id, data }, thunkApi) => {
  try {
    // Create a copy of the restaurant data and handle location serialization
    const restaurantData: Partial<CreateRestaurantFormData> = {
      ...data,
    };

    // Only include location if it exists and convert to string
    if (data.location) {
      restaurantData.location = data.location;
    } else {
      // Explicitly set to null if location is cleared
      delete restaurantData.location;
    }

    await api.Restaurant.update(id, restaurantData as CreateRestaurantFormData);
    thunkApi.dispatch(fetchRestaurantListAsync(undefined));
  } catch (error: unknown) {
    if (error instanceof AxiosError) {
      return thunkApi.rejectWithValue({ error: error.response?.data });
    }
    return thunkApi.rejectWithValue({ error: 'An unknown error occurred' });
  }
});

export const updateRestaurantSlice = createSlice({
  name: 'updateRestaurant',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateRestaurantAsync.pending, (state) => {
        state.status = 'pendingUpdate';
      })
      .addCase(updateRestaurantAsync.fulfilled, (state) => {
        state.status = 'idle';
      })
      .addCase(updateRestaurantAsync.rejected, (state) => {
        state.status = 'idle';
      });
  },
});

export default updateRestaurantSlice.reducer;
